import { call, put, take, takeEvery, takeLatest } from "redux-saga/effects";
import { eMonHocActionIds, eMonHocActionObj, IMonHocActionTypes } from "../../action-types/category/IMonHocActions";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { monHocApi } from "../../../api/category/monHocApi";
import { rootActions } from "../../actions/rootActions";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { ICongThucTinhDiem } from "../../../model/response/category/ICongThucTinhDiem";
import { IMonHocUpdateCongThucRequest } from "../../../model/request/category/IMonHocUpdateCongThucRequest";
import { IMonHoc } from "../../../model/response/category/IMonHoc";

const mainAction = rootActions.category.monHoc;
export function* monHocSaga(): any {
    yield takeLatest(eMonHocActionIds.LOAD_START,loadWorker);
    yield takeEvery(eMonHocActionIds.SAVE_CONG_THUC_START,saveCongThucMonWorker);
}

function* loadWorker(): any {
    const res: IBaseResponse = yield call(monHocApi.SelectAll);
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(toLowerCaseDeep(res.data)));
    }
    else{
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"))
    }
}

function* saveCongThucMonWorker(action: IMonHocActionTypes): any {
     debugger
    const monHocs = action.payload as IMonHoc[];
    let countSuccess = 0;
    let countError = 0;
    if (!monHocs || monHocs.length === 0) {
        yield put(mainAction.SAVE_CONG_THUC_ERROR("Không có môn học nào được chọn để cập nhật công thức."));
        return;
    }
    for (const monHoc of monHocs) {
       
        const id_mon = monHoc.id_mon;
        const id_cong_thuc = monHoc.id_cong_thuc_mon;
        const request = { id_cong_thuc } as IMonHocUpdateCongThucRequest;
        const res: IBaseResponse = yield call(monHocApi.UpdateCongThucMon, id_mon, request);
        if (res.is_success) {
            countSuccess++;
        }
        else{
             countError++;
        }
    }
    if (countSuccess > 0) {
        yield put(mainAction.SAVE_CONG_THUC_SUCCESS(undefined));
    }
    else {
        yield put(mainAction.SAVE_CONG_THUC_ERROR(`Cập nhật công thức thất bại cho ${countError} môn học.`));
    }  
}

